<template>
  <v-toolbar
    light
    color="white"
    class="elevation-2"
  >
    <v-toolbar-title v-if="isSearchPage">
      <a class="no-decoration grey--text text--darken-1"
         @click.prevent="$router.push({path: '/pliki/'})">Pliki</a>
      <v-icon color="grey" class="mx-2">chevron_right</v-icon>
      Wyniki wyszukiwania
      <span v-if="searchKey">{{searchKey}}</span>

    </v-toolbar-title>

    <v-toolbar-title v-if="!isSearchPage && (!breadcrumbs || breadcrumbs.length === 0)">
      Pliki
    </v-toolbar-title>
    <v-toolbar-title
      class="files-toolbar-title"
      v-if="!isSearchPage && (breadcrumbs && breadcrumbs.length > 0)">
      <BreadCurmbs
        :maxWidth="titleWidth"
      />
    </v-toolbar-title>

    <v-spacer></v-spacer>
    <div v-if="isAdmin" class="hidden-sm-and-down">
      <v-tooltip v-if="!isSearchPage" top>
        <v-btn
          slot="activator"
          :disabled="!clientId && !parentId"
          icon
          @click="selectFiles">
          <input ref="inputFile" type="file" @change="processFiles($event)" multiple
                 class="out-of-view"/>
          <v-icon color="primary">cloud_upload</v-icon>
        </v-btn>
        <span>Wyślij pliki</span>
      </v-tooltip>

      <v-tooltip v-if="!isSearchPage" top>
        <v-btn
          slot="activator"
          v-if="!isSearchPage"
          :disabled="!clientId && !parentId"
          @click="showCreateFolderDialog()"
          icon>
          <v-icon color="primary">create_new_folder</v-icon>
        </v-btn>
        <span>Utwórz folder</span>
      </v-tooltip>

      <v-tooltip v-if="!isSearchPage" top>
        <v-btn
          slot="activator"
          :disabled="selectedFiles.length <= 0"
          @click="showMoveDialog()"
          icon>
          <v-icon color="primary">folder_open</v-icon>
        </v-btn>
        <span>Przenieś do...</span>
      </v-tooltip>

      <v-tooltip v-if="!isSearchPage" top>
        <v-btn
          slot="activator"
          :disabled="!dirsSelected"
          @click="showPermissionsDialog()"
          icon>
          <v-icon color="primary">person_add</v-icon>
        </v-btn>
        <span>Zarządzaj dostępem</span>
      </v-tooltip>

      <v-tooltip v-if="!isSearchPage" top>
        <v-btn
          slot="activator"
          :disabled="selectedFiles.length <= 0"
          @click="showDeleteDialog()"
          icon>
          <v-icon color="primary">delete</v-icon>
        </v-btn>
        <span>Usuń</span>
      </v-tooltip>

      <v-tooltip top>
        <v-btn
          slot="activator"
          @click="refreshList()"
          icon>
          <v-icon color="primary">refresh</v-icon>
        </v-btn>
        <span>Odśwież</span>
      </v-tooltip>
    </div>
    <ToolbarMenu />
  </v-toolbar>
</template>

<script>
import jQuery from 'jquery';
import { mapGetters, mapActions } from 'vuex';
import BreadCurmbs from './Breadcrumbs/BreadcrumbsList.vue';
import ToolbarMenu from './Menus/ToolbarMenu.vue';

export default {
  name: 'folder-menu',
  data: () => ({
    titleWidth: null,
  }),
  components: {
    BreadCurmbs,
    ToolbarMenu,
  },
  computed: {
    ...mapGetters('files', [
      'breadcrumbs',
      'selectedFiles',
    ]),
    ...mapGetters('user', [
      'details',
      'role',
    ]),
    isAdmin() {
      return this.role === 'admin' || this.role === 'super-admin';
    },
    clientId() {
      return this.$route.params.clientId;
    },
    parentId() {
      return this.$route.params.id;
    },
    searchKey() {
      const { query } = this.$route;
      if (query.search && query.search.trim()) {
        return `dla: ${query.search.trim()}`;
      }
      return false;
    },
    isSearchPage() {
      return this.$route.name === 'searchFiles';
    },
    viewParams() {
      return {
        client_id: this.clientId,
        parent_item_id: this.parentId,
      };
    },
    dirsSelected() {
      return Boolean(this.selectedFiles.find(item => item.type === 1));
    },
    directoriesIds() {
      const ids = [];
      this.selectedFiles.forEach((file) => {
        if (file.type === 1) {
          ids.push(file.id);
        }
      });
      return ids;
    },
    itemsIds() {
      const ids = [];
      this.selectedFiles.forEach((file) => {
        ids.push(file.id);
      });
      return ids;
    },
    singleParams() {
      const { params } = this.$route;
      return {
        parent_item_id: params.id,
        client_id: params.clientId,
      };
    },
  },
  methods: {
    ...mapActions('files', [
      'getFilesList',
      'getSearchList',
      'setDialogVisbility',
      'setQuery',
    ]),
    refreshList() {
      const { query } = this.$route;
      this.setQuery(query);
      if (!this.isSearchPage) {
        this.getFilesList(this.singleParams);
      } else {
        this.getSearchList(this.singleParams);
      }
    },
    showDialog(dialogData) {
      const data = {
        ...dialogData,
        view: this.$route.name,
      };
      this.setDialogVisbility(data);
    },
    showCreateFolderDialog() {
      const dialogData = {
        type: 'createFolder',
        data: {
          client_id: this.clientId,
          parent_item_id: this.parentId,
        },
      };
      this.showDialog(dialogData);
    },
    showDeleteDialog() {
      const dialogData = {
        type: 'delete',
        items_id: this.itemsIds,
        viewParams: this.viewParams,
      };
      this.showDialog(dialogData);
    },
    showPermissionsDialog() {
      const hasFiles = this.selectedFiles.find(file => file.type === 2);
      const type = !hasFiles ? 'permissions' : 'permissions-alert';
      const dialogData = {
        type,
        data: {
          client_id: this.clientId,
          items_id: this.directoriesIds,
        },
        viewParams: this.viewParams,
      };
      this.showDialog(dialogData);
    },
    showMoveDialog() {
      const dialogData = {
        type: 'move',
        client_id: this.clientId,
        parent_item_id: this.parentId,
        viewParams: this.viewParams,
        items_id: this.itemsIds,
      };
      this.showDialog(dialogData);
    },
    selectFiles() {
      this.$refs.inputFile.click();
    },
    processFiles(event) {
      if (event.target.files.length > 0) {
        this.$eventBus.$emit('Files/FilesUpload/selectFiles', { files: event.target.files });
        jQuery(event.target).replaceWith(jQuery(event.target).val('').clone(true));
      }
    },
  },
};
</script>
